import { createContext, useCallback, useContext, useEffect, useState, type ReactNode } from 'react';
import type { SesionActual, UsuarioAdminDto } from '@reembolsables/shared';
import { api, ErrorApi } from '../lib/api';

interface EstadoSesion {
  usuario: UsuarioAdminDto | null;
  cargando: boolean;
  recargar: () => Promise<void>;
  salir: () => Promise<void>;
}

const Ctx = createContext<EstadoSesion | null>(null);

export function ProveedorSesion({ children }: { children: ReactNode }) {
  const [usuario, setUsuario] = useState<UsuarioAdminDto | null>(null);
  const [cargando, setCargando] = useState(true);

  const recargar = useCallback(async () => {
    try {
      const s = await api<SesionActual>('/api/admin/sesion');
      setUsuario(s.usuario);
    } catch (e) {
      if (e instanceof ErrorApi && e.estado === 401) setUsuario(null);
    } finally {
      setCargando(false);
    }
  }, []);

  useEffect(() => {
    void recargar();
  }, [recargar]);

  const salir = useCallback(async () => {
    await api('/api/admin/sesion', { method: 'DELETE' });
    setUsuario(null);
  }, []);

  return <Ctx.Provider value={{ usuario, cargando, recargar, salir }}>{children}</Ctx.Provider>;
}

export function useSesion(): EstadoSesion {
  const v = useContext(Ctx);
  if (!v) throw new Error('useSesion outside ProveedorSesion');
  return v;
}
